import React, { useEffect, useState } from 'react';
import '../../assets/css/Podcast.css'
import Footer from '../../Components/Footer/Footer';
import Header from '../../Components/Header/Header';
import InnerHeaderContent from '../../Components/Header/InnerHeaderContent';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { PodCastByPagination, PodcastGet } from '../../Redux/Auth/Auth_Action';

const Podcast = () => {
    const [podcast, setPodcast] = useState({ podcastData: [] });

    const dispatch = useDispatch();
    // let navigate = useNavigate();

    const GetPodcast = () => {
        dispatch(PodcastGet())
            .then((res) => {
                // console.log("working from podcast page here", res);
                setPodcast({ ...podcast, podcastData: res });
            }).catch((error) => {
                console.log('error from podcast page here', error);
            })
    }

    const PodCastPagination = (e) => {
        // console.log("working button", e);
        dispatch(PodCastByPagination(e))
            .then((res) => {
                // console.log('response from podcastpagination', res.data);
                setPodcast({ ...podcast, podcastData: res });
            }).catch((e) => {
                console.log(e, "error from podastpagination")
            })
    }

    // console.log("from main podcast page", podcast);

    useEffect(() => {
        GetPodcast();
    }, []);

    useEffect(() => {
        window.scroll(0, 0);
    }, [])

    return (
        <div className='tips_page'>
            <section className='reamining_header_background pos-rel'>
                <Header />
                <InnerHeaderContent pageName={"PODCAST"} />
            </section>
            <section className='podcast'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12 text-center'>
                            <p className='f-mon-reg f-30 lh-01 mb-0'>OUR PODCAST</p>
                            <p className='f-mon-bold f-50'>WATCH OUR PODCAST ANYTIME</p>
                            <div className='border-btm-pink-secondsec'></div>
                            <p className=' text-white f-mon-light f-20 mt-4'>
                                I along with many other top sports betting experts sit together to evaluate and share our thoughts on various matches, line moves, and thoughts on who will win making us the best sports predictions podcast.
                            </p>
                        </div>
                    </div>
                    <div className='row'>
                        {/* <div className='col-lg-4 mt-5'>
                            <div className='choose_category_pink'>
                                <p className='f-mon-bold f-20 catogry_tips'>
                                    CHOOSE CATEGORY
                                </p>
                                <p className='f-mon-reg f-15 category_tips_list_active'>
                                    COLLEGE CATEGORY
                                </p>
                                <p className='f-mon-reg f-15 category_tips_list'>
                                    COLLEGE BOWL
                                </p>
                                <p className='f-mon-reg f-15 category_tips_list'>
                                    COLLEGE HOOPS
                                </p>
                                <p className='f-mon-reg f-15 category_tips_list'>
                                    MARCH MADNESS
                                </p>
                                <p className='f-mon-reg f-15 category_tips_list'>
                                    UFC YEARLY PACKAGE
                                </p>
                                <p className='f-mon-reg f-15 category_tips_list last_index'>
                                    WEEKEND PASS FRIDAY
                                </p>
                            </div>
                        </div> */}

                        <div className='col-lg-12 mt-5'>
                            {/* {(podcast?.podcastData?.data?.[0].media_url?.slice(-3) === "mp4") ?
                                <video width="100%" height="300" controls controlsList="nodownload" >
                                    <source src={`${podcast?.podcastData?.data?.[0]?.media_url}`} type="video/mp4" />
                                </video>
                                :
                                <img src={podcast?.podcastData?.data?.[0]?.media_url} className="main_podcast" alt="pocast_main" />
                            }
                            <p className='f-mon-light f-15 mt-3'>
                                {podcast?.podcastData?.data?.[0].created_at.slice(0, 10)}
                            </p>
                            <p className='f-mon-reg f-25' dangerouslySetInnerHTML={{ __html: podcast?.podcastData?.data?.[0].description }}>
                            </p> */}
                            <div className='row'>
                                {podcast?.podcastData?.data?.map((item, index) => {
                                    console.log('from item podcast ', item);
                                    return (
                                        <div key={index} className='col-lg-4 '>
                                            <Link
                                                to={`/singlepodcast/${item.id}`}
                                                state={{ data: item, other_items: podcast?.podcastData?.data }}
                                            >
                                                {(item.media_url.slice(-3) === "mp4")
                                                    ?
                                                    <video width="100%" height="300" controlsList="nodownload" autoPlay loop muted >
                                                        <source src={`${item?.media_url}`} type="video/mp4" />
                                                    </video> :
                                                    <img src={item?.media_url} className="podcast_small_images" />
                                                }

                                                <p className='f-mon-light f-15 mb-1 mt-3 text-white'>
                                                    {/* {item?.created_at?.slice(0, 10)} */}
                                                    <span className='ml-1'>{item?.created_at?.slice(5, 7)}</span>
                                                    <span>{item?.created_at?.slice(7, 10)}</span>
                                                    <span>-{item?.created_at?.slice(0, 4)}</span>
                                                </p>
                                                <p className='f-mon-reg f-15 text-white'>{item.title}</p>
                                            </Link>
                                            {/* <div onClick={() => { navigate("/singlepodcast") }} className="cursor_pointer" >

                                            </div> */}
                                        </div>
                                    )
                                })}
                                {/* <div className='col-lg-12 text-center mt-5'>
                                    <p className='f-mon-reg f-16 clr-e0 cursor_pointer '>LOAD MORE</p>
                                </div> */}
                                <div className='col-lg-12 text-center mt-4'>
                                    {podcast?.podcastData?.links?.map((item, index) => {
                                        if (item.label === "&laquo; Previous") {
                                            item.label = "Previous";
                                            return (
                                                <button key={index + 100}
                                                    onClick={() => { PodCastPagination(item.url) }}
                                                    disabled={(item.url === null ? true : false)}
                                                    className='btn btn-light bt-pagination-all'>
                                                    {item.label}
                                                </button>
                                            )
                                        } else if (item.label === "Next &raquo;") {
                                            item.label = "Next";
                                            return (
                                                <button key={index + 100}
                                                    onClick={() => { PodCastPagination(item.url) }}
                                                    disabled={(item.url === null ? true : false)}
                                                    className='btn btn-light bt-pagination-all'>
                                                    {item.label}
                                                </button>
                                            )
                                        } else {
                                            return (
                                                <button key={index + 100}
                                                    onClick={() => { PodCastPagination(item.url) }}
                                                    disabled={(item.url === null ? true : false)}
                                                    className='btn btn-light bt-pagination-all'>
                                                    {item.label}
                                                </button>
                                            )
                                        }
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default Podcast;